<section class="page-container my-4 lg:my-8">
	<h1 class="text-2xl sm:text-5xl text-[#7D5B20] font-medium lg:px-10 mb-2">
		Hear from our <span class="text-black">Customers</span>
	</h1>
	<div class="flex items-center gap-1 lg:px-10 mb-4 lg:mb-8">
		<span class="text-lg sm:text-xl">{{ reviewCount }} Shop Reviews</span>
		<span *ngFor="let _ of stars; let i = index">
			<span class="star" [class.filled]="rating > i">&#9733;</span>
		</span>
	</div>
	<fb-review-list class="w-full"></fb-review-list>
</section>
